/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { useTranslation } from "react-i18next";
import { AuroraBackground } from "@/components/AuroraBackground";
import { Reveal } from "@/components/Reveal";
import { StoreBadgeGroup } from "@/components/StoreBadges";
import { Compass, MessageCircle, Brain, Sparkles } from "lucide-react";

const ForMenPage = () => {
  const { t } = useTranslation("site");
  const tk = (k, fb) => t(`men.${k}`, fb);
  return (
    <>
      <section className="relative pb-12">
        <AuroraBackground variant="soft" />
        <div className="relative mx-auto max-w-7xl px-5 lg:px-8 pt-8 lg:pt-12">
          <Reveal>
            <p className="eyebrow">{tk("kicker")}</p>
            <h1 className="mt-3 font-serif text-[2.6rem] sm:text-5xl lg:text-[4.4rem] tracking-tight font-light leading-[1.02] max-w-4xl">
              {tk("title1")}{" "}<em className="italic aurora-shimmer-text">{tk("title2")}</em>{" "}{tk("title3")}
            </h1>
            <p className="mt-6 max-w-2xl text-white/75 text-lg font-light leading-relaxed">{tk("subtitle")}</p>
            <div className="mt-8">
              <StoreBadgeGroup startLabel={tk("cta")} />
              <p className="mt-3 text-xs text-white/45 tracking-wide">{t("home.freeBadge")}</p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="relative py-16">
        <div className="mx-auto max-w-6xl px-5 lg:px-8 grid md:grid-cols-2 gap-5">
          {[
            { icon: <Compass size={20} />, title: tk("card1T"), body: tk("card1B") },
            { icon: <MessageCircle size={20} />, title: tk("card2T"), body: tk("card2B") },
            { icon: <Brain size={20} />, title: tk("card3T"), body: tk("card3B") },
            { icon: <Sparkles size={20} />, title: tk("card4T"), body: tk("card4B") },
          ].map((c) => (
            <Reveal key={c.title}>
              <div className="aurora-card p-7 h-full bg-[var(--aurora-quests)]">
                <span className="size-11 rounded-2xl bg-white/8 flex items-center justify-center text-[var(--aurora-gold)] mb-4">{c.icon}</span>
                <h3 className="font-serif text-2xl">{c.title}</h3>
                <p className="mt-3 text-white/75 font-light leading-relaxed">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Pattern interrupt — one line, no fluff */}
      <section className="relative py-14">
        <div className="mx-auto max-w-3xl px-5 lg:px-8 text-center">
          <Reveal>
            <p className="font-serif text-2xl sm:text-4xl italic aurora-shimmer-text leading-snug">
              {tk("storyLine", "The 2 AM Google search never fixed the 8 PM silence.")}
            </p>
          </Reveal>
        </div>
      </section>

      <section className="relative py-20">
        <div className="mx-auto max-w-3xl px-5 lg:px-8 text-center">
          <Reveal>
            <h2 className="font-serif text-3xl sm:text-4xl tracking-tight font-light leading-tight">
              {tk("closingTitle1")}{" "}<em className="italic text-[var(--aurora-gold)]">{tk("closingTitle2")}</em>
            </h2>
            <p className="mt-4 text-white/72 font-light">{tk("closingBody")}</p>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <StoreBadgeGroup startLabel={t("common.startFree")} />
            </div>
            <p className="mt-4 text-xs text-white/45 tracking-wide">{t("common.freeFooter")}</p>
          </Reveal>
        </div>
      </section>
    </>
  );
};

export default ForMenPage;
